<template>
  <div>
    <b-row>
      <b-col>
        <Autocomplete
          v-model="contractPartner"
          :items="filteredContractPartners"
          :component-item="contractPartnerTemplate"
          :get-label="getContractPartnerLabel"
          :min-len="0"
          :auto-select-one-item="false"
          :placeholder="$t('message.contractPartnerDetails.placeholder.contractPartner')"
          @update-items="updateContractPartners"
          @item-selected="updateContractPartner"/>
      </b-col>
    </b-row>

    <b-row
      v-if="showForm"
      class="mt-5">
      <b-col md="12" lg="12" xl="10">
        <b-form>
          <b-form-row>
            <b-col cols="3" class="col-form-label px-3">
              <label class="w-100 text-right">
                {{ $t('message.contractPartnerDetails.label.contractPartnerName') }}
                <span class="text-danger">*</span>
              </label>
            </b-col>
            <b-col cols="9" class="px-3">
              <b-form-group :state="$v.formData.contractPartnerName.$error ? false : null"
                            :invalid-feedback="$t('error.contractPartnerDetails.contractPartner.contractPartnerName')">
                <b-input id="company"
                         class="rounded-0"
                         v-model="formData.contractPartnerName"
                         :state="$v.formData.contractPartnerName.$error ? false : null"
                         @change="$v.formData.contractPartnerName.$touch()"/>
              </b-form-group>
            </b-col>
          </b-form-row>

          <b-form-row>
            <b-col cols="3" class="col-form-label px-3">
              <label class="w-100 text-right">{{ $t('message.contractPartnerDetails.label.domain') }}</label>
            </b-col>
            <b-col cols="9" class="px-3">
              <b-form-group
                :state="$v.formData.domain.$error ? false : null"
                :invalid-feedback="$t('error.contractPartnerDetails.contractPartner.domain')">
                <b-input
                  id="url"
                  class="rounded-0"
                  v-model="formData.domain"
                  :state="$v.formData.domain.$error ? false : null"
                  @change="$v.formData.domain.$touch()"/>
              </b-form-group>
            </b-col>
          </b-form-row>

          <b-form-row>
            <b-col cols="3" class="col-form-label px-3">
              <label class="w-100 text-right">
                {{ $t('message.contractPartnerDetails.label.email') }}
                <span class="text-danger">*</span>
              </label>
            </b-col>
            <b-col cols="9" class="px-3">
              <b-form-group
                :state="$v.formData.email.$error ? false : null"
                :invalid-feedback="$t('error.contractPartnerDetails.contractPartner.email')">
                <b-input
                  id="url"
                  class="rounded-0"
                  v-model="formData.email"
                  :state="$v.formData.email.$error ? false : null"
                  @change="$v.formData.email.$touch()"/>
              </b-form-group>
            </b-col>
          </b-form-row>

          <b-form-row>
            <b-col cols="3" class="col-form-label px-3">
              <label class="w-100 text-right">{{ $t('message.contractPartnerDetails.label.street') }}</label>
            </b-col>
            <b-col cols="9" class="px-3">
              <b-form-group
                :state="$v.formData.street.$error ? false : null"
                :invalid-feedback="$t('error.contractPartnerDetails.contractPartner.street')">
                <b-input
                  id="street"
                  class="rounded-0"
                  v-model="formData.street"
                  :state="$v.formData.street.$error ? false : null"
                  :@change="$v.formData.street.$touch()"/>
              </b-form-group>
            </b-col>
          </b-form-row>

          <b-form-row>
            <b-col cols="3" class="col-form-label px-3">
              <label class="w-100 text-right">{{ $t('message.contractPartnerDetails.label.streetNumber') }}</label>
            </b-col>
            <b-col cols="9" class="px-3">
              <b-form-group
                :state="$v.formData.streetNumber.$error ? false : null"
                :invalid-feedback="$t('error.contractPartnerDetails.contractPartner.streetNumber')">
                <b-input
                  id="street"
                  class="rounded-0"
                  v-model="formData.streetNumber"
                  :state="$v.formData.streetNumber.$error ? false : null"
                  :@change="$v.formData.streetNumber.$touch()"/>
              </b-form-group>
            </b-col>
          </b-form-row>

          <b-form-row>
            <b-col cols="3" class="col-form-label px-3">
              <label class="w-100 text-right">
                {{ $t('message.contractPartnerDetails.label.postalCode') }}
                <span class="text-danger">*</span>
              </label>
            </b-col>
            <b-col cols="9" class="px-3">
              <b-form-group
                :state="$v.formData.postalCode.$error ? false : null"
                :invalid-feedback="$t('error.contractPartnerDetails.contractPartner.postalCode')">
                <b-input
                  id="postalCode"
                  class="rounded-0"
                  v-model="formData.postalCode"
                  :state="$v.formData.postalCode.$error ? false : null"
                  @change="$v.formData.postalCode.$touch()"/>
              </b-form-group>
            </b-col>
          </b-form-row>

          <b-form-row>
            <b-col cols="3" class="col-form-label px-3">
              <label class="w-100 text-right">
                {{ $t('message.contractPartnerDetails.label.city') }}
                <span class="text-danger">*</span>
              </label>
            </b-col>
            <b-col cols="9" class="px-3">
              <b-form-group
                :state="$v.formData.city.$error ? false : null"
                :invalid-feedback="$t('error.contractPartnerDetails.contractPartner.city')">
                <b-input
                  id="city"
                  class="rounded-0"
                  v-model="formData.city"
                  :state="$v.formData.city.$error ? false : null"
                  @change="$v.formData.city.$touch()"/>
              </b-form-group>
            </b-col>
          </b-form-row>

          <b-form-row>
            <b-col cols="3" class="col-form-label px-3">
              <label class="w-100 text-right">
                {{ $t('message.contractPartnerDetails.label.postOfficeBox') }}
              </label>
            </b-col>
            <b-col cols="9" class="px-3">
              <b-form-group
                :state="$v.formData.postOfficeBox.$error ? false : null"
                :invalid-feedback="$t('error.contractPartnerDetails.contractPartner.postOfficeBox')">
                <b-input
                  id="postalCode"
                  class="rounded-0"
                  v-model="formData.postOfficeBox"
                  :state="$v.formData.postOfficeBox.$error ? false : null"
                  @change="$v.formData.postOfficeBox.$touch()"/>
              </b-form-group>
            </b-col>
          </b-form-row>

          <b-form-row>
            <b-col cols="3" class="col-form-label px-3">
              <label class="w-100 text-right">{{ $t('message.contractPartnerDetails.label.country') }}</label>
            </b-col>
            <b-col cols="9" class="px-3">
              <b-form-group
                :state="$v.formData.country.$error ? false : null"
                :invalid-feedback="$t('error.contractPartnerDetails.contractPartner.country')">
                <b-input
                  id="country"
                  class="rounded-0"
                  v-model="formData.country"
                  :state="$v.formData.country.$error ? false : null"
                  @change="$v.formData.country.$touch()"/>
              </b-form-group>
            </b-col>
          </b-form-row>
          <b-form-row>
            <b-col offset="3" class="col-form-label px-3 ">
              <div class="requieredFields text-right">
                <span v-html=" $t('message.contractPartnerDetails.label.requiredFields')"></span>
              </div>
            </b-col>
          </b-form-row>
          <b-form-row>
            <b-col offset="3" class="px-3">
              <b-form-group
                :state="$v.formData.confirmed.$error ? false : null"
                :invalid-feedback="$t('error.contractPartnerDetails.contractPartner.confirmed')">
                <b-form-checkbox
                  id="confirm"
                  v-model="formData.confirmed"
                  :state="$v.formData.confirmed.$error ? false : null"
                  @change="$v.formData.confirmed.$touch()">
                  {{ $t('message.contractPartnerDetails.label.confirmed') }}
                </b-form-checkbox>
              </b-form-group>
            </b-col>
          </b-form-row>

          <b-form-row>
            <b-col offset="3" class="px-3">
              <b-form-text>
                {{ $t('message.contractPartnerDetails.infoText') }}
              </b-form-text>
            </b-col>
          </b-form-row>
        </b-form>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import {email, required} from 'vuelidate/lib/validators'
  import Autocomplete from 'v-autocomplete'
  import ContractPartnerTemplate from '@/components/contracts/ContractPartnerTemplate'
  import utils from '@/utils'

  export default {
    components: {
      Autocomplete,
      ContractPartnerTemplate
    },
    computed: {
      contractPartners () {
        const contractPartners = this.$store.getters.contractPartners
        const additionalContractPartnerIndex = contractPartners.findIndex((contractPartner) => contractPartner.id === -1)
        if (additionalContractPartnerIndex !== -1) {
          contractPartners.splice(additionalContractPartnerIndex, 1)
        }
        contractPartners.push({
          id: -1,
          contractPartnerName: this.$t('message.contractList.infoCard.step1.contractPartnerName')
        })
        return contractPartners
      },
      contractPartner: {
        get () {
          return this.$store.getters.currentContract.contractPartner
        },
        set (contractPartner) {
          this.selectedContractPartner = contractPartner
        }
      },
      showForm () {
        this.isFormVisible = false
        if (this.contractPartner && this.contractPartner.id === -1) {
          const searchValue = this.formData.searchValue ? this.formData.searchValue : this.formData.contractPartnerName
          this.$v.$reset()
          this.formData.templateId = null
          this.formData.contractPartnerName = searchValue
          this.isFormVisible = true
        } else if (this.contractPartner) {
          this.formData = this.contractPartner
          this.formData.templateId = this.contractPartner.templateId ? this.contractPartner.templateId : null
          this.isFormVisible = true
        }
        return this.isFormVisible
      }
    },
    data () {
      return {
        formData: {},
        isFormVisible: false,
        selectedContractPartner: this.contractPartner,
        contractPartnerTemplate: ContractPartnerTemplate,
        filteredContractPartners: this.contractPartners
      }
    },
    methods: {
      getContractPartner () {
        return this.formData
      },
      getContractPartnerLabel (contractPartner) {
        return contractPartner ? contractPartner.contractPartnerName : ''
      },
      setFormVisible (isVisible) {
        this.isFormVisible = isVisible
      },
      stashContractPartner () {
        let currentContractPartner = this.getContractPartner()
        this.$store.commit('updateContractPartner', currentContractPartner)
      },
      resetContractPartner () {
        this.$v.$reset()
        this.$store.commit('updateContractPartner', {})
        this.formData = {}
      },
      createEmptyContractPartner () {
        this.$v.$reset()
        this.$store.commit('updateContractPartner', this.contractPartners[this.contractPartners.length - 1])
      },
      updateContractPartner (contractPartner) {
        this.$v.$reset()
        if (this.contractPartner && this.contractPartner.id) {
          // this results in the "create new CP" being assigned a wrong id, leading to the crutch in ContractPartnerTemplate
          contractPartner.id = this.contractPartner.id
        }
        if (contractPartner && contractPartner.hasOwnProperty('isTemplate') && contractPartner.isTemplate === true) {
        // if (contractPartner && contractPartner.hasOwnProperty('isDeletable') && contractPartner.isDeletable === true) {
          if (contractPartner.templateId === null) {
            contractPartner.templateId = contractPartner.id
          }
        }
        this.$store.commit('updateContractPartner', contractPartner)
      },
      updateContractPartners (text) {
        this.formData.searchValue = text
        // this.formData.contractPartnerName = text
        this.filteredContractPartners = this.contractPartners.filter((contractPartner) => {
          return contractPartner.contractPartnerName.toLowerCase().includes(text.toLowerCase()) || contractPartner.id === -1
        })
      }
    },
    validations: {
      formData: {
        contractPartnerName: {
          required
        },
        domain: {
          isValidDomain: utils.validators.isValidDomain
        },
        email: {
          email,
          required
        },
        street: {},
        streetNumber: {},
        postOfficeBox: {},
        postalCode: {
          required
        },
        city: {
          required
        },
        country: {},
        confirmed: {
          required
        }
      }
    }
  }
</script>
<style scoped>
  .requieredFields {
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/components/contracts/ContractPartnerDetails.vue